import Extension from './extension';
import { createStorefrontApiClient } from '@shopify/storefront-api-client';

class ShopifyStorefrontAPI extends Extension {
  name = 'ShopifyStorefrontAPI';
  client;

  constructor() {
    super();

    let key = document.querySelector("body").dataset.storefrontApiKey;

    if(!key){
      console.warn(`${this.logPrefix}`, `No Storefront API key found`);
      return;
    }

    this.client = createStorefrontApiClient({
      storeDomain: location.origin,
      apiVersion: '2025-01',
      publicAccessToken: key,
    });
    
    MP.registerHelper("executeGQL", this.executeGQL, this);
    MP.registerHelper("idToGraphQlId", this.idToGraphQlId, this);
  }

  async executeGQL(query, options = {}) {
    return await this.client.request(query, options);
  }

  idToGraphQlId(id, type) {
    switch(type){
      case "variant": type = "ProductVariant"; break;
      case "product": type = "Product"; break;
    }
    return `gid://shopify/${type}/${id}`;
  }

  async example() {
    const productQuery = `
      query ProductQuery($handle: String) {
        product(handle: $handle) {
          id
          title
          handle
        }
      }
    `;

    const {data, errors, extensions} = await this.client.request(productQuery, {
      variables: {
        handle: 'trtl-pillow-cool',
      },
    });

    console.log(data, errors, extensions);
  }
}

export default ShopifyStorefrontAPI;